import { Component } from '@angular/core';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-icf-description-table',
  standalone: true,
  imports: [MatTableModule],
  templateUrl: './icf-description-table.component.html',
  styleUrl: './icf-description-table.component.scss',
})
export class IcfDescriptionTableComponent {}
